// extracted by mini-css-extract-plugin
export default {"divider-container":"divider_divider-container__st1Vz"};